import React, { useState } from 'react';

import ExtensionMessage from 'components/Practice/shared/ExtensionMessage';
import Recorder from 'components/ui/MediaRecorder';
import { useFeatureFlags } from 'hooks/index';
import AutomatedAnalysisAudioMessage from '../shared/AutomatedAnalysisAudioMessage';

const ScreenRecordingRepeatableQuestion = props => {
  const {
    data,
    meta,
    disabled,
    handleBadUploadType,
    hasZiggeoForAllMedia,
    provider,
    recordButtonText,
    saveMedia,
    setFinishedRecording,
    setIsTabDisabled,
    setUploadFinished,
    setUploadStarted,
  } = props;
  const { currentUserId, progressId, questionId, hasAutomatedAnalysis } = data;
  const { apiKey } = meta;
  const [recordingNotSupported, setRecordingNotSupported] = useState(false);
  const seismicRecordingEnabled = useFeatureFlags(
    'readiness-enable-seismic-recording',
  );

  /**************** SCREEN FUNCTIONS *******************/

  const onRecordingNotSupported = () => {
    if (!recordingNotSupported) {
      setRecordingNotSupported(true);
    }
  };

  const triggerRecordingEvents = () => {
    setFinishedRecording(false);
    setIsTabDisabled(true);
  };

  return (
    <>
      {!seismicRecordingEnabled && (
        <ExtensionMessage
          hasZiggeoForAllMedia={hasZiggeoForAllMedia}
          recordingNotSupported={recordingNotSupported}
        />
      )}
      <AutomatedAnalysisAudioMessage
        hasAutomatedAnalysis={hasAutomatedAnalysis}
      />
      <Recorder
        allowDragAndDrop
        allowScreen
        allowUpload
        allowWebcam={false}
        apiKey={apiKey}
        currentUserId={currentUserId}
        disabled={disabled}
        handleBadUploadType={handleBadUploadType}
        onBrowserRecordingNotSupported={onRecordingNotSupported}
        onRecording={triggerRecordingEvents}
        onUploading={triggerRecordingEvents}
        progressId={progressId}
        provider={provider}
        questionId={questionId}
        recordButtonText={recordButtonText}
        saveMedia={saveMedia}
        setUploadingComplete={setUploadFinished}
        setUploadStarted={setUploadStarted}
        webcamPlaybackEnabled
        seismicRecordingEnabled={seismicRecordingEnabled}
        wide
      />
    </>
  );
};

export default ScreenRecordingRepeatableQuestion;
